import type { Styles } from 'common/types';

export const styles: Styles = {
  accordion: {
    border: '1px solid',
    borderColor: 'divider',
    borderRadius: '8px !important',
    boxShadow: 'none',
    '&:before': { display: 'none' },
  },
  accordionSummary: {
    borderRadius: '8px',
    px: 2.5,
    minHeight: 52,
    '&.Mui-expanded': { minHeight: 52 },
    '& .MuiAccordionSummary-content': { margin: '12px 0' },
    '& .MuiAccordionSummary-content.Mui-expanded': { margin: '12px 0' },
  },
  accordionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    mr: 1,
  },
  accordionDetails: {
    borderTop: '1px solid',
    borderColor: 'divider',
    p: 2.5,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  detailsSection: {
    mt: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
};
